import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceOrderService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listServiceOrders(filters = "") {
    return this.http.get(this.api+`/ordem-servico${filters}`);
  }

  addServiceOrders(raw) {
    return this.http.post(this.api+`/ordem-servico`, raw);
  }

  getServiceOrder(id) {
    return this.http.get(this.api+`/ordem-servico/${id}`);
  }

  returnServiceOrder(raw) {
    return this.http.put(this.api+`/ordem-servico/retornar-loja`, raw);
  }

  forwardServiceOrder(raw) {
    return this.http.put(this.api+`/ordem-servico/encaminhar-supervisor`, raw);
  }
}
